import { Col, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useQuestions, useSurveys } from '../../api/Surveys';

function CodeFrameSelect({
  value = { surveyId: null, codeFrameId: null },
  onChange = () => {},
  questionIndex = null,
  onQuestionSelect = () => {},
  label,
}) {
  const { data: surveys, isLoading: surveysLoading } = useSurveys({
    select: (data) => data.data.filter((s) => !s.is_demo),
  });

  const { data: questions, isFetching: questionsFetching } = useQuestions(
    { surveyId: value.surveyId },
    {
      enabled: !!value.surveyId,
      select: (data) => data.data.filter((q) => q.has_themes && q.code_frame_id),
    },
  );

  const onSurveyChange = (newSurveyId) => {
    onChange({ surveyId: newSurveyId, codeFrameId: null });
    onQuestionSelect(questionIndex, null);
  };

  const onQuestionChange = (newCodeFrameId) => {
    onChange({ ...value, codeFrameId: newCodeFrameId });
    onQuestionSelect(questionIndex, newCodeFrameId);
  };

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>{label}</Col>
      <Col span={12}>
        <Select
          value={value.surveyId}
          placeholder="Select survey"
          onChange={onSurveyChange}
          loading={surveysLoading}
          options={surveys?.map((s) => ({
            value: s.id,
            label: s.name,
          }))}
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        />
      </Col>
      <Col span={12}>
        <Select
          value={value.codeFrameId}
          placeholder="Select question"
          onChange={onQuestionChange}
          loading={questionsFetching}
          disabled={!value.surveyId || questionsFetching}
          options={questions?.map((q) => ({
            value: q.code_frame_id,
            label: q.text,
          }))}
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
        />
      </Col>
    </Row>
  );
}

CodeFrameSelect.propTypes = {
  value: PropTypes.shape({
    surveyId: PropTypes.number,
    codeFrameId: PropTypes.number,
  }),
  onChange: PropTypes.func,
  questionIndex: PropTypes.string,
  onQuestionSelect: PropTypes.func,
  label: PropTypes.string.isRequired,
};

export default CodeFrameSelect;
